module.exports = __webpack_public_path__ + "img/red-trash-icon.645ec185.svg";